import { render } from "./TestimonialCarousel.vue?vue&type=template&id=47e0a54c&scoped=true"
import script from "./TestimonialCarousel.vue?vue&type=script&lang=js"
export * from "./TestimonialCarousel.vue?vue&type=script&lang=js"

import "./TestimonialCarousel.vue?vue&type=style&index=0&id=47e0a54c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e0a54c"]])

export default __exports__